import { SENSITIVE_STRING } from "@smithy/smithy-client";
import { TranslateServiceException as __BaseException } from "./TranslateServiceException";
export class ConcurrentModificationException extends __BaseException {
    name = "ConcurrentModificationException";
    $fault = "client";
    Message;
    constructor(opts) {
        super({
            name: "ConcurrentModificationException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ConcurrentModificationException.prototype);
        this.Message = opts.Message;
    }
}
export class ConflictException extends __BaseException {
    name = "ConflictException";
    $fault = "client";
    Message;
    constructor(opts) {
        super({
            name: "ConflictException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ConflictException.prototype);
        this.Message = opts.Message;
    }
}
export const EncryptionKeyType = {
    KMS: "KMS",
};
export const ParallelDataFormat = {
    CSV: "CSV",
    TMX: "TMX",
    TSV: "TSV",
};
export const ParallelDataStatus = {
    ACTIVE: "ACTIVE",
    CREATING: "CREATING",
    DELETING: "DELETING",
    FAILED: "FAILED",
    UPDATING: "UPDATING",
};
export class InternalServerException extends __BaseException {
    name = "InternalServerException";
    $fault = "server";
    Message;
    constructor(opts) {
        super({
            name: "InternalServerException",
            $fault: "server",
            ...opts,
        });
        Object.setPrototypeOf(this, InternalServerException.prototype);
        this.Message = opts.Message;
    }
}
export class InvalidParameterValueException extends __BaseException {
    name = "InvalidParameterValueException";
    $fault = "client";
    Message;
    constructor(opts) {
        super({
            name: "InvalidParameterValueException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, InvalidParameterValueException.prototype);
        this.Message = opts.Message;
    }
}
export class InvalidRequestException extends __BaseException {
    name = "InvalidRequestException";
    $fault = "client";
    Message;
    constructor(opts) {
        super({
            name: "InvalidRequestException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, InvalidRequestException.prototype);
        this.Message = opts.Message;
    }
}
export class LimitExceededException extends __BaseException {
    name = "LimitExceededException";
    $fault = "client";
    Message;
    constructor(opts) {
        super({
            name: "LimitExceededException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, LimitExceededException.prototype);
        this.Message = opts.Message;
    }
}
export class TooManyRequestsException extends __BaseException {
    name = "TooManyRequestsException";
    $fault = "client";
    Message;
    constructor(opts) {
        super({
            name: "TooManyRequestsException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, TooManyRequestsException.prototype);
        this.Message = opts.Message;
    }
}
export class TooManyTagsException extends __BaseException {
    name = "TooManyTagsException";
    $fault = "client";
    ResourceArn;
    constructor(opts) {
        super({
            name: "TooManyTagsException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, TooManyTagsException.prototype);
        this.ResourceArn = opts.ResourceArn;
    }
}
export class ResourceNotFoundException extends __BaseException {
    name = "ResourceNotFoundException";
    $fault = "client";
    Message;
    constructor(opts) {
        super({
            name: "ResourceNotFoundException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ResourceNotFoundException.prototype);
        this.Message = opts.Message;
    }
}
export const JobStatus = {
    COMPLETED: "COMPLETED",
    COMPLETED_WITH_ERROR: "COMPLETED_WITH_ERROR",
    FAILED: "FAILED",
    IN_PROGRESS: "IN_PROGRESS",
    STOPPED: "STOPPED",
    STOP_REQUESTED: "STOP_REQUESTED",
    SUBMITTED: "SUBMITTED",
};
export const Brevity = {
    ON: "ON",
};
export const Formality = {
    FORMAL: "FORMAL",
    INFORMAL: "INFORMAL",
};
export const Profanity = {
    MASK: "MASK",
};
export const TerminologyDataFormat = {
    CSV: "CSV",
    TMX: "TMX",
    TSV: "TSV",
};
export const Directionality = {
    MULTI: "MULTI",
    UNI: "UNI",
};
export const MergeStrategy = {
    OVERWRITE: "OVERWRITE",
};
export const DisplayLanguageCode = {
    DE: "de",
    EN: "en",
    ES: "es",
    FR: "fr",
    IT: "it",
    JA: "ja",
    KO: "ko",
    PT: "pt",
    ZH: "zh",
    ZH_TW: "zh-TW",
};
export class UnsupportedDisplayLanguageCodeException extends __BaseException {
    name = "UnsupportedDisplayLanguageCodeException";
    $fault = "client";
    Message;
    DisplayLanguageCode;
    constructor(opts) {
        super({
            name: "UnsupportedDisplayLanguageCodeException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, UnsupportedDisplayLanguageCodeException.prototype);
        this.Message = opts.Message;
        this.DisplayLanguageCode = opts.DisplayLanguageCode;
    }
}
export class InvalidFilterException extends __BaseException {
    name = "InvalidFilterException";
    $fault = "client";
    Message;
    constructor(opts) {
        super({
            name: "InvalidFilterException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, InvalidFilterException.prototype);
        this.Message = opts.Message;
    }
}
export class UnsupportedLanguagePairException extends __BaseException {
    name = "UnsupportedLanguagePairException";
    $fault = "client";
    Message;
    SourceLanguageCode;
    TargetLanguageCode;
    constructor(opts) {
        super({
            name: "UnsupportedLanguagePairException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, UnsupportedLanguagePairException.prototype);
        this.Message = opts.Message;
        this.SourceLanguageCode = opts.SourceLanguageCode;
        this.TargetLanguageCode = opts.TargetLanguageCode;
    }
}
export class ServiceUnavailableException extends __BaseException {
    name = "ServiceUnavailableException";
    $fault = "server";
    Message;
    constructor(opts) {
        super({
            name: "ServiceUnavailableException",
            $fault: "server",
            ...opts,
        });
        Object.setPrototypeOf(this, ServiceUnavailableException.prototype);
        this.Message = opts.Message;
    }
}
export class DetectedLanguageLowConfidenceException extends __BaseException {
    name = "DetectedLanguageLowConfidenceException";
    $fault = "client";
    Message;
    DetectedLanguageCode;
    constructor(opts) {
        super({
            name: "DetectedLanguageLowConfidenceException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, DetectedLanguageLowConfidenceException.prototype);
        this.Message = opts.Message;
        this.DetectedLanguageCode = opts.DetectedLanguageCode;
    }
}
export class TextSizeLimitExceededException extends __BaseException {
    name = "TextSizeLimitExceededException";
    $fault = "client";
    Message;
    constructor(opts) {
        super({
            name: "TextSizeLimitExceededException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, TextSizeLimitExceededException.prototype);
        this.Message = opts.Message;
    }
}
export const TerminologyDataFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.File && { File: SENSITIVE_STRING }),
});
export const ImportTerminologyRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.TerminologyData && { TerminologyData: TerminologyDataFilterSensitiveLog(obj.TerminologyData) }),
});
export const DocumentFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Content && { Content: SENSITIVE_STRING }),
});
export const TranslateDocumentRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Document && { Document: DocumentFilterSensitiveLog(obj.Document) }),
});
export const TranslatedDocumentFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Content && { Content: SENSITIVE_STRING }),
});
export const TranslateDocumentResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.TranslatedDocument && { TranslatedDocument: TranslatedDocumentFilterSensitiveLog(obj.TranslatedDocument) }),
});
